var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.714%",
    y1: "93.485%",
    x2: "93.608%",
    y2: "6.619%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF543E",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C837AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-63.2%",
    y: "-56%",
    width: "226.3%",
    height: "213.1%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 40,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(-165 -146)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.096a8 8 0 1 1-16-.191 8 8 0 0 1 16 .19",
    fill: "url(#b)",
    transform: "translate(165 146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.477 152.146c-.021-.478-.098-.807-.21-1.092a2.196 2.196 0 0 0-.52-.798 2.215 2.215 0 0 0-.796-.519c-.287-.11-.614-.188-1.092-.209-.482-.023-.635-.028-1.857-.028s-1.375.005-1.855.026c-.479.021-.808.099-1.092.21-.303.114-.574.29-.799.52a2.216 2.216 0 0 0-.519.796c-.11.287-.188.614-.209 1.092-.023.482-.028.635-.028 1.857s.005 1.375.026 1.855c.021.478.099.807.21 1.092.114.302.292.573.52.798.225.228.498.406.797.518.286.111.613.189 1.092.21.48.02.633.026 1.855.026s1.375-.005 1.855-.026c.479-.021.807-.099 1.092-.21a2.302 2.302 0 0 0 1.317-1.316c.111-.287.189-.614.21-1.092.02-.48.026-.633.026-1.855s-.002-1.375-.023-1.855zm-.81 3.675c-.02.44-.094.676-.155.835a1.493 1.493 0 0 1-.855.854c-.158.062-.397.136-.835.155-.475.021-.617.026-1.818.026-1.202 0-1.346-.005-1.819-.026-.44-.02-.677-.093-.835-.155a1.385 1.385 0 0 1-.517-.336 1.4 1.4 0 0 1-.336-.516c-.061-.159-.135-.398-.155-.836-.02-.474-.026-.617-.026-1.818 0-1.2.005-1.345.026-1.818.02-.44.094-.676.155-.835.072-.195.186-.372.338-.517.146-.149.321-.263.517-.335.158-.062.397-.136.835-.155.475-.021.617-.026 1.818-.026 1.203 0 1.346.005 1.819.026.44.02.677.093.835.155.195.072.373.186.517.335.15.146.264.322.336.517.061.159.135.398.154.835.022.475.027.618.027 1.818 0 1.201-.005 1.342-.027 1.817z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.002 151.689a2.313 2.313 0 1 0 0 4.625 2.313 2.313 0 0 0 0-4.625zm0 3.812a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM175.946 151.597a.54.54 0 1 1-1.08 0 .54.54 0 0 1 1.08 0z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.39f249118482e1ec2ac5ccaf60e0575b.svg";
export { ForwardRef as ReactComponent };